/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCopiedProjectFieldDto } from '../../models/backend-copied-project-field-dto';
import { BackendPatchedCopiedProjectFieldRequestDto } from '../../models/backend-patched-copied-project-field-request-dto';

export interface ProjectsCopiedProjectPartialUpdate$FormData$Params {
  id: number;
  body?: BackendPatchedCopiedProjectFieldRequestDto;
}

export function projectsCopiedProjectPartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: ProjectsCopiedProjectPartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendCopiedProjectFieldDto>> {
  const rb = new RequestBuilder(rootUrl, projectsCopiedProjectPartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendCopiedProjectFieldDto>;
    }),
  );
}

projectsCopiedProjectPartialUpdate$FormData.PATH = '/api/projects/copied_project/{id}/';
